import React from "react";
import {Form, FormInstance, Modal} from "antd";
import TextArea from "antd/es/input/TextArea";

interface IRejectModalProps {
    assetRejectModal: boolean;
    handleRejectModalClose: () => void;
    assetRejectForm: FormInstance;
    handleRejectionSubmit: () => void;
}

const AssetRejectModal = (props: IRejectModalProps) => {

    return (
        <Modal
            open={props.assetRejectModal}
            onCancel={props.handleRejectModalClose}
            okText={"Reject"}
            className={'hrms-app asset-reject-modal'}
            onOk={props.handleRejectionSubmit}
        >
            <Form layout={"vertical"} form={props.assetRejectForm}>
                <Form.Item
                    label={"Write Rejection Message"}
                    name={'rejectMessage'}
                    rules={[{required: true, message: "Please write rejection message!"}]}
                >
                    <TextArea placeholder={"Describe why rejecting request..."}/>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default AssetRejectModal;
